import React, { useState } from 'react';
import { CheckCircleIcon, CalendarIcon, Share2Icon, MapPinIcon, ChevronDownIcon, ChevronUpIcon, CopyIcon } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { Header } from '../components/Header';
import { BottomNav } from '../components/BottomNav';
import { Button } from '../components/Button';
export function BookingConfirmationScreen() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const [showPolicy, setShowPolicy] = useState(false);
  const copyReference = () => {
    navigator.clipboard.writeText(`#${id}`);
    alert('Booking reference copied!');
  };
  return <div className="h-screen w-full flex flex-col bg-[#f8f9fa]" data-id="element-307">
      <Header title="Booking Details" showBack={true} onBack={() => navigate('/bookings')} actionButton={<button className="p-2 hover:bg-gray-100 rounded-full" data-id="element-309">
            <Share2Icon className="w-5 h-5 text-[#1f5070]" data-id="element-310" />
          </button>} data-id="element-308" />

      <div className="flex-1 overflow-auto px-4 py-6 space-y-4" data-id="element-311">
        {/* Success icon */}
        <div className="flex justify-center mb-4" data-id="element-312">
          <div className="w-20 h-20 bg-[#43A047] rounded-full flex items-center justify-center animate-scale-in" data-id="element-313">
            <CheckCircleIcon className="w-12 h-12 text-white" data-id="element-314" />
          </div>
        </div>

        {/* QR Code section */}
        <div className="bg-white rounded-2xl shadow-lg p-6 text-center" data-id="element-315">
          <div className="flex justify-center mb-4" data-id="element-316">
            <div className="w-48 h-48 bg-white rounded-lg flex items-center justify-center border-2 border-gray-200 p-2" data-id="element-317">
              <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-318">
                <rect width="100" height="100" fill="white" data-id="element-319" />
                <rect x="10" y="10" width="15" height="15" fill="black" data-id="element-320" />
                <rect x="35" y="10" width="15" height="15" fill="black" data-id="element-321" />
                <rect x="60" y="10" width="15" height="15" fill="black" data-id="element-322" />
                <rect x="10" y="35" width="15" height="15" fill="black" data-id="element-323" />
                <rect x="60" y="35" width="15" height="15" fill="black" data-id="element-324" />
                <rect x="10" y="60" width="15" height="15" fill="black" data-id="element-325" />
                <rect x="35" y="60" width="15" height="15" fill="black" data-id="element-326" />
                <rect x="60" y="60" width="15" height="15" fill="black" data-id="element-327" />
              </svg>
            </div>
          </div>
          <p className="text-sm text-[#666666] mb-1" data-id="element-328">Show this at check-in</p>
          <p className="text-xs text-gray-400" data-id="element-329">Tap to enlarge</p>
        </div>

        {/* Booking details card */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden" data-id="element-330">
          {/* Court photo banner */}
          <div className="relative h-36 bg-gradient-to-br from-[#1f5070] to-[#3dc7e3]" data-id="element-331">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/v8z3dRRZD7DwLj1nmZiJkZ/CourtImageRotate1.webp" alt="Court" className="w-full h-full object-cover opacity-60" data-id="element-332" />
            <div className="absolute top-4 left-4" data-id="element-333">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fYmeFB35HhojatJVz8XpFb/PickleballBruneiLogoC.webp" alt="Pickleball Brunei" className="h-8 object-contain" data-id="element-334" />
            </div>
          </div>

          <div className="p-6" data-id="element-335">
            <h2 className="text-2xl font-bold text-[#1f5070] mb-2" data-id="element-336">Court A</h2>
            <p className="text-[#3dc7e3] text-lg mb-1" data-id="element-337">
              Tomorrow • Nov 22 • 3:00 PM - 4:00 PM
            </p>
            <p className="text-[#666666] mb-4" data-id="element-338">Duration: 1 hour</p>

            <div className="border-t border-gray-200 pt-4 mb-4" data-id="element-339">
              <div className="flex justify-between items-center mb-2" data-id="element-340">
                <span className="text-[#666666]" data-id="element-341">Total Paid</span>
                <span className="text-2xl font-bold text-[#1f5070]" data-id="element-342">
                  300 UC
                </span>
              </div>
              <p className="text-sm text-[#666666]" data-id="element-343">UniPlay Credits</p>
            </div>

            <div className="flex items-center justify-between bg-[#f8f9fa] rounded-lg p-3" data-id="element-344">
              <span className="text-[#1f5070] font-mono" data-id="element-345">#{id}</span>
              <button onClick={copyReference} className="flex items-center gap-1 text-[#3dc7e3] text-sm font-bold" data-id="element-346">
                <CopyIcon className="w-4 h-4" data-id="element-347" />
                Copy
              </button>
            </div>
          </div>
        </div>

        {/* Venue information */}
        <div className="bg-white rounded-2xl shadow-lg p-4" data-id="element-348">
          <div className="h-24 bg-gray-200 rounded-lg mb-3 overflow-hidden" data-id="element-349">
            <iframe src="https://www.openstreetmap.org/export/embed.html?bbox=114.73276%2C4.73345%2C114.73676%2C4.73745&layer=mapnik&marker=4.73545%2C114.73476" className="w-full h-full border-0" title="Venue map" data-id="element-350" />
          </div>
          <h3 className="text-lg font-bold text-[#1f5070] mb-2" data-id="element-351">
            Pickleball Lamunin
          </h3>
          <div className="flex items-start gap-2 mb-3" data-id="element-352">
            <MapPinIcon className="w-4 h-4 text-[#3dc7e3] mt-0.5 flex-shrink-0" data-id="element-353" />
            <p className="text-sm text-[#666666]" data-id="element-354">
              No.44, Kampong Kiudang, Tutong, Brunei
            </p>
          </div>
          <Button variant="primary" fullWidth onClick={() => navigate('/map')} data-id="element-355">
            Get Directions
          </Button>
        </div>

        {/* Action buttons */}
        <div className="grid grid-cols-2 gap-3" data-id="element-356">
          <Button variant="secondary" onClick={() => alert('Add to calendar')} data-id="element-357">
            <div className="flex items-center justify-center gap-2" data-id="element-358">
              <CalendarIcon className="w-5 h-5" data-id="element-359" />
              <span data-id="element-360">Calendar</span>
            </div>
          </Button>

          <Button variant="secondary" onClick={() => alert('Share booking')} data-id="element-361">
            <div className="flex items-center justify-center gap-2" data-id="element-362">
              <Share2Icon className="w-5 h-5" data-id="element-363" />
              <span data-id="element-364">Share</span>
            </div>
          </Button>
        </div>

        {/* Cancellation policy */}
        <div className="bg-white rounded-2xl shadow-lg p-4" data-id="element-365">
          <button onClick={() => setShowPolicy(!showPolicy)} className="w-full flex items-center justify-between" data-id="element-366">
            <span className="text-sm font-bold text-[#1f5070]" data-id="element-367">
              Cancellation Policy
            </span>
            {showPolicy ? <ChevronUpIcon className="w-5 h-5 text-gray-400" data-id="element-368" /> : <ChevronDownIcon className="w-5 h-5 text-gray-400" data-id="element-369" />}
          </button>
          {showPolicy && <div className="mt-3 text-sm text-[#666666]" data-id="element-370">
              <p className="mb-2" data-id="element-371">
                Free cancellation up to 2 hours before your booking.
              </p>
              <p data-id="element-372">
                Cancellations within 2 hours will forfeit 50% of the booking
                fee.
              </p>
            </div>}
        </div>

        {/* Cancel button */}
        <Button variant="outline" fullWidth className="!text-[#E53935] !border-[#E53935]" data-id="element-373">
          Cancel Booking
        </Button>
      </div>

      <BottomNav data-id="element-374" />
    </div>;
}